/**
 * @ AlarmStatusDialog.vue
 * @Description 弹窗 告警状态
 * @Author CC
 * @Date 2025/11/28
 */
/* HTML */
<template>
	<div v-if="dialogForm.dialogFormVisible">
		<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" custom-class="form-dialog" v-dialogDrag class="dialog_title" @close="handleDialogClose">
			<DeviceAlarm />
		</el-dialog>
	</div>
</template>

/* JS */
<script>
	// 组件 告警状态
	import DeviceAlarm from '@/views/system-outdoor/alarm/DeviceAlarm';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
		name: "AlarmStatusDialog",

		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
		components: {
			// 组件 告警状态
			DeviceAlarm,
		}, // components

		/**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
		props: {

		}, // props

		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				/**
				 * @Des 弹出层属性
				 * @Auth CC
				 * @Date 2025/11/28
				 */
				dialogForm: {
					title: '',
					dialogFormVisible: false,
					submitButton: '',
				},
			} // return
		}, // data

		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {

		}, // created

		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {

		}, // mounted

		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {

		}, // beforeDestroy

		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {

		}, // destroyed

		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Description
			 * @Param 打开弹窗
			 * @Auth CC
			 * @Date 2025/11/28
			 */
			openDialog(title, button) {
				this.dialogForm.title = title;
				this.dialogForm.dialogFormVisible = true;
				this.dialogForm.submitButton = button;
			}, // openDialog
			/**
			 * @Description
			 * @Param 关闭弹窗
			 * @Auth CC
			 * @Date 2025/11/28
			 */
			handleDialogClose() {
				this.dialogForm.dialogFormVisible = false;
			}, // handleDialogClose
		}, // methods

		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {

		}, // watch

		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {

		}, // computed

	} // export default
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 90%;
	}
	
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}
	
	/deep/ .paginationStyle {
		.el-pagination__sizes {
			.el-input {
				.el-input__inner {
					width: 160px;
					
				}// el-input__inner
			}// el-input
		}// el-pagination__sizes
	}// paginationStyle
	
	/deep/ .el-pagination__jump {
		.el-input {
			width: 80px !important;
		}
	}// el-pagination__jump
</style>


// WEBPACK FOOTER //
// src/components_outdoor/Home/AlarmStatusDialog.vue